import PropTypes from 'prop-types';

import { Abstrap } from '..';

const propTypes = { ...Abstrap.propTypes, position: PropTypes.oneOf(['left', 'right']) };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    position: 'right',
};

class ButtonIcon extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            position,
        } = this.props;
        return [
            'c-btn__icon',
            position === 'right' ? 'c-btn__icon--right' : false,
            position === 'left' ? 'c-btn__icon--left' : false,
            className,
        ];
    }

}

ButtonIcon.propTypes = propTypes;

ButtonIcon.defaultProps = defaultProps;

export default ButtonIcon;
